import '../vendor/hammer.min.js';

export default (slidesCount) => ({
  slide: 0,
  isMobile: window.matchMedia('(max-width: 639px)').matches,
  init() {
    this.slides = this.isMobile ? slidesCount - 1 : slidesCount - 3;
    this.k = this.isMobile ? 100 : 33.33;

    let hammertime = new Hammer(this.$el);
    hammertime.on('swipeleft', () => this.slideLeft());
    hammertime.on('swiperight', () => this.slideRight());
  },
  slideRight() {
    if (this.slide != 0) {
      -- this.slide;
      this.update();
    }
  },
  slideLeft() {
    if (this.slide != this.slides) {
      ++ this.slide;
      this.update();
    }
  },
  update() {
    this.$refs.body.style.transform = `translateX(-${this.slide * this.k}%)`;
  }
})